import SenderIdMaskingModal from './modal/SenderIdMaskingModal'
import ErrorModal from '../Modal/ErrorModal'
import ListPagination from '../../PaymentRequest/ListPagination'
import TableContent from '../../../utils/components/Table/TableContent'
import {SenderIDColumn} from './SenderIDsColumn'
import {useSenderIdProvider} from '../context/SenderIdProvider'
import {KTIcon} from '../../../../_metronic/helpers'
import SenderIdFilter from './SenderIdFilter'
import {useAuth} from '../../auth'
import {
  ListViewContext,
  ListViewProvider,
  useListView,
} from '../../../utils/contextProvider/ListViewProvider'
import SelectList from '../../../utils/components/SelectList'
import BulkSenderCreate from './modal/BulkSenderCreate'
import BulkUploadFeedback from './modal/BulkUploadFeedback'
import BulkUpdateNonBranded from './modal/BulkUpdateNonBranded'
import DownloadButton from './DownloadButton'
import {app_id} from '../../config'
import {Helmet} from 'react-helmet-async'
import {senderIdsColumns} from './senderIdsColumns'

const SenderIdContent = () => {
  const {currentUser} = useAuth()
  const {
    isLoading,
    filteredSender,
    setUpdateSender,
    downloadSenderIds,
    totalElement,
    handlePageChange,
    apiError,
    setApiError,
    searchTerm,
    setSearchTerm,
    parameters,
  } = useSenderIdProvider() || {}

  const {selected, clearSelected} = useListView()

  const onPageChange = (pagenumber: number) => {
    handlePageChange(pagenumber)
    clearSelected()
  }

  return (
    <div>
      <div className='d-flex justify-content-between align-items-center mb-4 gap-4 flex-wrap'>
        <div className='card-title'>
          {/* <div className='d-flex align-items-center position-relative my-1'>
            <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
            <input
              type='text'
              data-kt-user-table-filter='search'
              className='form-control form-control custom-input w-350px ps-14'
              placeholder='Search Sender Id'
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div> */}
          {selected.length === 0 && (
            <div className='d-flex gap-4 align-items-center'>
              <SenderIdFilter />
              {filteredSender.length > 0 && (
                <p className='m-0 fs-4 text-gray-700 fw-semibold'>
                  Showing {filteredSender.length} of {totalElement}
                </p>
              )}
            </div>
          )}
        </div>

        <div className='card-title'>
          {selected.length > 0 ? (
            <div className='d-flex align-items-center'>
              {/* <SelectList context={ListViewContext} /> */}
              <div className='fw-bolder me-5 fs-4'>
                <span className='me-2 '>{selected.length}</span> Selected
              </div>
              {currentUser?.user_profile === 1 ||
                (currentUser?.user_profile === 2 && (
                  <button
                    type='button'
                    className='ms-4 btn btn-primary'
                    data-bs-toggle='modal'
                    data-bs-target='#kt_modal_11'
                  >
                    Bulk Update
                  </button>
                ))}
            </div>
          ) : (
            <div className='d-flex gap-4 flex-wrap'>
              {/* <button
                type='button'
                className='btn btn-light-primary me-3'
                onClick={downloadSenderIds}
              >
                <KTIcon iconName='exit-up' className='fs-2' />
                Download
              </button> */}
              <DownloadButton />
              {currentUser?.user_profile === 1 || currentUser?.user_profile === 2 ? (
                <>
                  <button
                    type='button'
                    className='btn btn-primary'
                    data-bs-toggle='modal'
                    data-bs-target='#kt_modal_1'
                    onClick={() => setUpdateSender(undefined)}
                  >
                    <KTIcon iconName='plus' className='fs-2' />
                    Create Sender Id
                  </button>
                  <button
                    type='button'
                    className='btn btn-info'
                    data-bs-toggle='modal'
                    data-bs-target='#kt_modal_2'
                    onClick={() => setUpdateSender(undefined)}
                  >
                    <KTIcon iconName='plus' className='fs-2' />
                    Add Bulk
                  </button>
                </>
              ) : null}
            </div>
          )}
        </div>
      </div>

      <div className='card mb-5 mb-xl-10'>
        <TableContent
          isLoading={isLoading}
          tableData={filteredSender}
          tableColumn={senderIdsColumns(currentUser?.user_profile!)}
        >
          <ListPagination
            totalElement={totalElement}
            itemsPerPage={parameters.pageSize}
            currentPage={parameters.pageNumber}
            handlePageChange={onPageChange}
            isLoading={isLoading}
          />
        </TableContent>
        <div className='card-footer'>
          <SenderIdMaskingModal />
          {apiError?.isError && <ErrorModal apiError={apiError} setApiError={setApiError} />}
        </div>
      </div>

      <BulkSenderCreate />
      <BulkUploadFeedback />
      <BulkUpdateNonBranded />
    </div>
  )
}

export const SenderId = () => {
  const {isLoading, filteredSender} = useSenderIdProvider()

  return (
    <ListViewProvider isLoading={isLoading} data={filteredSender}>
      <Helmet>
        <title>Sender ID</title>
      </Helmet>
      <SenderIdContent />
    </ListViewProvider>
  )
}

export default SenderId
